import { render, staticRenderFns } from "./AutomationSection.vue?vue&type=template&id=514f77da&"
import script from "./AutomationSection.vue?vue&type=script&lang=js&"
export * from "./AutomationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports